// @ts-check
import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

export const useUi = defineStore('ui', () => {
    const progress = ref(true)

    /**
     *
     * @param {boolean} value
     * @returns {boolean}
     */
    function updateProgress(value) {
        progress.value = value
        return value
    }

    const isProgress = computed(() => progress.value)

    return {
        progress,
        updateProgress,
        isProgress
    }
})
